var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 137.2 137.2",
    style: {
      enableBackground: "new 0 0 137.2 137.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.6,0C30.7,0,0,30.7,0,68.6s30.7,68.6,68.6,68.6c37.9,0,68.6-30.7,68.6-68.6S106.5,0,68.6,0z M74.6,111.7 c-2,2-4.6,3-7.5,3c-3,0-5.5-1-7.5-3c-2-2-3-4.5-3-7.4c0-3,1-5.5,3-7.5c2-2,4.5-3,7.5-3c2.9,0,5.4,1,7.5,3c2.1,2,3.1,4.6,3.1,7.6 C77.7,107.2,76.7,109.7,74.6,111.7z M94,56.5c-1.3,2.8-3,5.3-4.9,7.2c-1.8,1.8-4.2,3.8-7,6c-3,2.3-5.1,4.2-6.4,5.7 c-1,1.2-1.6,2.7-1.6,4.6c0,1.5,0.1,3.1,0.2,4.8l0.2,2.4H58.3l-0.5-1.6c-0.5-1.8-0.8-3.8-0.8-5.9c0-4.2,1.1-7.7,3.2-10.5 c1.9-2.5,4.8-5.3,8.4-8.3c3.2-2.6,5.6-4.9,7.1-6.9c1.4-1.8,2-4,2-6.6c0-2.5-0.8-4.6-2.6-6.2c-1.8-1.7-4.3-2.5-7.7-2.5 c-2,0-3.8,0.4-5.2,1.2c-1.5,0.8-2.7,1.8-3.6,2.8c-1.1,1.3-1.5,2.2-1.6,2.7l-0.8,2.5l-16-8l1.2-2c1.3-2.2,2.6-4.3,4-6.2 c1.6-2.1,4.2-4,8.1-6.1c3.9-2,8.8-3,14.6-3c5.3,0,10.1,1,14.2,3.1c4.3,2.1,7.6,4.9,10,8.5c2.4,3.6,3.6,7.7,3.6,12.1 C96,50.1,95.3,53.6,94,56.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/About-icon.03b4e20c92280c41971b744338480af1.svg";
export { ForwardRef as ReactComponent };